import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import DataTable from "react-data-table-component";

import queryString from "query-string";
import BasePage from "../BasePage";
import { Row, Col, Button } from "react-bootstrap";
import { fetchGenericData } from "../../../../webservices/generic/genericDataWs";
import { showDataFetchError } from "../../../../actions/generic/fuseAlerts";
import { addToastAction } from "../../../../actions/generic/toastActions";
import { ToastTypes } from "../../modals/FuseToast";
import {
  insertRoles,
  updateRoles,
  deleteRole,
} from "../../../../webservices/roles/rolesWs";
import FuseCollapsiblePanel from "../../FuseCollapsiblePanel";

import FuseInputBox from "../../inputFields/FuseInputBox";
import FuseToolbar from "./../../../generic/FuseToolbar";
import { v4 as uuidv4 } from "uuid";
import DataTableExtensions from "react-data-table-component-extensions";
import { fuseDataTableCustomStyles } from "../../../../scss/generic/fuse-react-data-table-theme";
import FuseForm from "../../FuseForm";
import OverviewPanelSearchWrapper from "../generic/OverviewPanelSearchWrapper";

class RolesPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      originalData: [],
      isInEdit: false,
      isInMark: false,
      isDirty: false,
      isLoading: false,
      selectedRows: [],
      selectedRow: {},
    };
  }

  componentDidMount() {
    this.loadPanelData();
  }

  drawTable = () => {
    if (this.state.data.length == 0) {
      return <p>No Data</p>;
    }

    const conditionalRowStyles = [
      {
        when: (row) =>
          !_.isEmpty(this.state.selectedRow) &&
          row.id === this.state.selectedRow.id,
        style: {
          backgroundColor: "#e3f2fd", //Todo: This should use bootstrap colours. But how???
        },
      },
      {
        when: (row) => row.isDeleted === true,
        style: {
          backgroundColor: "red", //Todo: This should use bootstrap colours. But how???
        },
      },
    ];

    const minWidthForCol = (type) => {
      const medium = "200px";
      const large = "300px";
      const xlarge = "400px";
      const normal = "170px";
      const small = "100px";
      const xsmall = "50px";
      const action = "50px"; //"20px";

      switch (type.toLowerCase()) {
        case "action":
          return action;
        case "boolean":
          return small;
        case "int64":
          return small;
        case "datetime":
          return normal;
        case "text":
          return large;
        default:
          return normal;
      }
    };

    let columns = roleColumns.map((col) => {
      return {
        name: col.description,
        selector: col.name,
        sortable: true,
        minWidth: minWidthForCol(col.columnType),
        width: minWidthForCol(col.columnType),
        cell: (row, index, column) => {
          let key = `${row[col.name]}_${col.name}_${new Date()}`;
          let id = `${row["id"]}_${col.name}`;
          return (
            <FuseInputBox
              key={key}
              id={id}
              name={col.name}
              length={col.length}
              required={!col.nullable}
              regExp={col.regex}
              regExpMissmatchMessage={col.regExpMissmatchMessage}
              type={col.columnType}
              value={row[col.name]}
              editable={
                this.state.isInEdit && (row.isInserted || col.updateable)
              }
              dropDownDisplayValues={col.dropDownDisplayValues}
              dropKeyColumn="key"
              dropValueColumn="value"
              dropDownValues={col.dropDownValues}
              onChange={(val) => {
                row[col.name] = val; //We update the field
                row.isEdited = true;
                this.state.isEdited = true;
              }}
            />
          );
        },
        compact: true,
      };
    });

    columns.unshift({
      name: "",
      text: "",
      className: "d-flex",
      minWidth: minWidthForCol("action"),
      width: minWidthForCol("action"),
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <i className="fa fa-link" onClick={(e) => this.selectRow(row)}></i>
          </div>
        );
      },
    });  

    return (
      <div className="fuseHeader mt-2">
        <FuseToolbar
          showAdd
          showEdit={!this.state.isInEdit}
          showSave={this.state.isInEdit || this.state.isDirty}
          showUndo={this.state.isInEdit || this.state.isDirty}
          /*showCopy={this.state.selectedRows.length >=1}*/ showDelete={
            this.state.selectedRows.length >= 1
          }
          onEditClicked={this.onEditClicked}
          onUndoClicked={this.onUndoClicked}
          // onSaveClicked={this.onSaveClicked}
          onAddClicked={this.onAddClicked}
          onDeleteClicked={this.onDeleteClicked}
          //saveDisabled={this.state.isInEdit}
        />
        <OverviewPanelSearchWrapper
          data={this.state.data}
          columns={columns}
          panelColumns={
            !_.isEmpty(this.state.data[0])
              ? Object.keys(this.state.data[0])
              : []
          }
        >
          {(filteredItems, resetPaginationToggle, subHeaderComponentMemo) => {
            return (
              <DataTable
                title={this.props.title}
                highlightOnHover={true}
                onSelectedRowsChange={(val) => {
                  this.setState({ selectedRows: val.selectedRows });
                }}
                selectableRowsHighlight
                clearSelectedRows={this.state.clearSelected}
                selectableRows={true}
                columns={columns}
                dense
                data={filteredItems}
                subHeader={this.state.data.length > 0}
                subHeaderComponent={subHeaderComponentMemo}
                pagination
                paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                noHeader
                responsive
                theme="fuseDataTableTheme"
                customStyles={fuseDataTableCustomStyles}
                conditionalRowStyles={conditionalRowStyles}
              />
            );
          }}
        </OverviewPanelSearchWrapper>
      </div>
    );
  };

  onAddClicked = () => {
    let newRow = { id: uuidv4(), isInserted: true, name: "", displayname: "" };
    let data = this.state.data;

    this.setState({ data: [newRow, ...data], isInEdit: true });
  };

  onSaveClicked = () => {
    let inserted = this.state.data.filter(
      (x) => x.isInserted === true && isNaN(x.id)
    );
    let edited = this.state.data.filter(
      (x) => x.isEdited === true && !isNaN(x.id)
    );
    let deleted = this.state.data.filter(
      (x) => x.isDeleted === true && !isNaN(x.id)
    );

    inserted.map((role) => {
      this.insertPanelRow(role);
    });

    edited.map((role) => {
      this.updatePanelRole(role);
    });

    deleted.map((role) => {
      this.deletePanelRow(role);
    });
  };

  onUndoClicked = () => {
    let data = _.cloneDeep(this.state.originalData);
    this.setState({ data: [...data], isInEdit: false, isDirty: false });
  };

  onEditClicked = () => {
    let inEdit = this.state.isInEdit == true;
    this.setState({ isInEdit: !inEdit });
  };

  onDeleteClicked = () => {
    //We add our selectedRows to any deletedRows we may already have
    let selectedRow = this.state.selectedRows.includes(this.state.selectedRow)
      ? null
      : this.state.selectedRow;
    //We set our selected rows as deleted. Since tableUiSelectedRows is a reference to the actual data objects held in this.state.data, we can simply set the property on the object
    this.state.selectedRows.map((x) => (x.isDeleted = true));
    //Now we refresh our state
    this.setState(
      {
        data: this.state.data,
        selectedRow: selectedRow,
        isDirty: true,
        clearSelected: true,
      },
      () => {
        this.setState({ clearSelected: false }); //On callback of "true" clearSelected, we reset it to false...not ideal since we're now rendering this component twice. But the DataTable clearSelected seems to require a "toggle" for clearSelected to work
      }
    );
  };

  selectRow = (row) => {
    this.props.rowSelected(row);
    this.setState({ selectedRow: row });
  };

  render() {
    return (
      <FuseForm
        onSubmit={(e) => {
          this.onSaveClicked();
        }}
      >
        <FuseCollapsiblePanel
          isLoading={this.state.isLoading}
          title={this.props.title}
        >
          {this.drawTable()}
          <hr />
          {/* {JSON.stringify(this.state.data)}<br/>
                    {"#" + (((1 << 24) * Math.random()) | 0).toString(16)} */}
        </FuseCollapsiblePanel>
      </FuseForm>
    );
  }

  componentDidUpdate(prevProps) {}

  loadPanelData = () => {
    var query = {
      panelId: 1,
      queryOptions: [],
      schema: "dbo",
      screenId: "110",
      tableName: "abproles",
    };
    fetchGenericData(query)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error fetching roles data:");
          console.log(JSON.stringify(response.error));
          this.props.showDataFetchError(response.error.message);
          this.props.addToast(ToastTypes.ERROR, "Error fetching records");
        } else if (response.data.success === true) {
          let data = response.data.result.data.map((x) => {
            return { selected: false, ...x };
          });

          let copy = _.cloneDeep(data);
          this.setState({
            isInEdit: false,
            isDirty: false,
            selectedRows: [],
            data: [...data],
            originalData: [...copy],
          });
        } else {
          console.log("Error fetching roles data:");
          console.log(JSON.stringify(response.data));
          this.props.showDataFetchError();
          this.props.addToast(ToastTypes.ERROR, "Error fetching records");
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
        this.props.showDataFetchError(error.message);
        //this.props.addToast(ToastTypes.ERROR, "Error fetching records");
      });
  };

  deletePanelRow = (row) => {
    var query = {
      id: row.id,
      panelId: 2,
      screenId: "110",
    };
    deleteRole(query)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error deleting role data:");
          console.log(JSON.stringify(response.error));
          this.props.showDataFetchError(response.error.message);
          this.props.addToast(ToastTypes.ERROR, "Error deleting records");
        } else if (response.data.success === true) {
          this.loadPanelData();
          this.setState({ isDirty: false, isInEdit: false, selectedRows: [] });
          this.props.addToast(ToastTypes.SUCCESS, "Record deleted");
        } else {
          console.log("Error deleting role data:");
          console.log(JSON.stringify(response.data));
          this.props.showDataFetchError();
          this.props.addToast(ToastTypes.ERROR, "Error deleting records");
        }
        if (response.data.success !== true) this.onUndoClicked();
      })
      .catch(function (error) {
        //onUndoClicked();
        console.log("exception:" + error);
        this.props.showDataFetchError(error.message);
        //this.props.addToast(ToastTypes.ERROR, "Error deleting records");
      });
  };

  insertPanelRow = (row) => {
    var query = {
      data: {
        isInserted: true,
        isDeleted: false,
        isUpdated: true,
        isSelected: false,
        $$hashKey: "object:270",
        name: row.name,
        displayname: row.displayname,
      },
      panelId: 2,
      screenId: "110",
      timeZone: -120,
    };

    insertRoles(query)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error inserting role data:");
          console.log(JSON.stringify(response.error));
          this.props.showDataFetchError(response.error.message);
          this.props.addToast(ToastTypes.ERROR, "Error inserting records");
        } else if (response.data.success === true) {
          this.loadPanelData();
          this.setState({ isDirty: true, isInEdit: false });
          this.props.addToast(ToastTypes.SUCCESS, "Record inserted ");
        } else {
          console.log("Error inserting role data:");
          console.log(JSON.stringify(response.data));
          this.props.showDataFetchError();
          this.props.addToast(ToastTypes.ERROR, "Error inserting records");
        }

        if (response.data.success !== true) this.onUndoClicked();
      })
      .catch(function (error) {
        //this.onUndoClicked();
        console.log("exception:" + error);
        this.props.showDataFetchError(error.message);
        //this.props.addToast(ToastTypes.ERROR, "Error inserting records");
      });
  };

  //isUpdate might be true
  updatePanelRole = (row) => {
    if (_.isEmpty(row)) return;

    var query = {
      data: {
        id: row.id,
        isInserted: false,
        isDeleted: false,
        isUpdated: false,
        isSelected: false,
        name: row.name,
        displayname: row.displayname,
      },
      id: row.id,
      panelId: 2,
      screenId: "110",
      timeZone: -120,
    };

    updateRoles(query)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error updating role data:");
          console.log(JSON.stringify(response.error));
          this.props.showDataFetchError(response.error.message);
          this.props.addToast(ToastTypes.ERROR, "Error updating records");
        } else if (response.data.success === true) {
          this.loadPanelData();
          this.setState({ isDirty: false, isInEdit: false });
          this.props.addToast(ToastTypes.SUCCESS, "Record Updated");
        } else {
          console.log("Error updating role data:");
          console.log(JSON.stringify(response.data));
          this.props.showDataFetchError();
          this.props.addToast(ToastTypes.ERROR, "Error updating records");
        }

        if (response.data.success !== true) this.onUndoClicked();
      })
      .catch(function (error) {
        //this.onUndoClicked();
        console.log("exception:" + error);
        this.props.showDataFetchError(error.message);
        //this.props.addToast(ToastTypes.ERROR, "Error updating records");
      });
  };
}

RolesPanel.propTypes = {};

const roleColumns = [
  {
    name: "name",
    description: "Name",
    columnType: "text",
    updateable: false,
    regExpMissmatchMessage: "Non-alphanumeric characters are not allowed.",
    regex: "[\\w]+",
  },
  {
    name: "displayname",
    description: "Display Name",
    columnType: "text",
    updateable: true,
  },
];

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps, (dispatch, ownProps) => ({
  showDataFetchError: (exception) => dispatch(showDataFetchError(exception)),
  addToast: (type, text) => dispatch(addToastAction(type, text)), //Not including third parameter...let it default
}))(RolesPanel);
